<template>
  <el-menu-item
    :index="index"
  >
    <router-link
      class="menu-router-link"
      :to="route"
    >
      <i v-if="icon" :class="icon" class="menu-router-link-icon"></i>
      <span class="menu-router-link-text"><slot></slot></span>
    </router-link>
  </el-menu-item>
</template>

<script>

export default {
  name: "menu-item",
  components: {},

  props: {
    index: {type: String},
    route: {type: Object},
    label: {type: String},
    icon: {type: String, default: null},
  },

  watch: {},
  computed: {},
  data() {
    return {

    }
  },
  mounted() {
  },
  methods: {

  }
}
</script>


<style lang="scss">
@import "node_modules/element-ui/packages/theme-chalk/src/common/var.scss";
@import "@/assets/css/project-variables";

.menu-router-link{
  text-decoration: none;
  color: $--color-text-secondary;
}
.menu-router-link-icon {
  display: none;
}
</style>